import createCollectionStore from '../create';
import gql from 'nanographql';
import { getHeaders } from '../../fetch';
import { APP_GRAPHQL } from '../../config';
import UUID from 'uuid';

const LIST_APPS = gql`
query listApps {
  apps: listApps {
    uuid
    name
    package
  }
}
`;

const SAVE_APP = gql`
mutation saveApp($data: AppInput!) {
  saved: saveApp(data: $data) {
    uuid
    name
    package
  }
}
`;

const DELETE_APP = gql`
mutation removeApp($uuid: UUID!) {
  removed: removeApp(uuid: $uuid)
}
`;

async function invokeGraphQL(query, variables = {}) {
  const body = query(variables);
  const response = await fetch(
    APP_GRAPHQL,
    {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json'
      },
      body
    }
  );
  if (!response.ok) {
    throw new Error('Could not complete request');
  }
  const { data, errors } = await response.json();
  if (errors) {
    throw new Error(errors[0].message || 'Could not complete request');
  }
  return data;
}

export default createCollectionStore(
  'App',
  async () => {
    const result = await invokeGraphQL(
      LIST_APPS
    );
    return result.apps;
  },
  'uuid',
  [],
  {
    save: async (state, actions, app) => {
      const input = {
        ...app,
        uuid: app.uuid || UUID.v4()
      };
      await invokeGraphQL(
        SAVE_APP,
        {
          data: {
            uuid: input.uuid,
            name: input.name || '',
            package: input.package || ''
          }
        }
      );
      await actions.updateCache(input);
      return input;
    },
    remove: async (state, actions, uuid) => {
      await invokeGraphQL(
        DELETE_APP,
        {
          uuid
        }
      );
      await actions.removeCached(uuid);
    }
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/app.js